import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  BetaLocales,
  SupportedLocales
} from '../../../components/locale/locale'
import { LocaleSelector } from '../../../components/locale-selector'

export interface LocaleSelectorWrapperProps {
  readonly betaLanguageEnabled: boolean
  readonly selectedLocale: SupportedLocales
  readonly disabled: boolean
  readonly onChange: (locale: SupportedLocales | BetaLocales) => void
}
function LocaleSelectorWrapper({
  betaLanguageEnabled = false,
  selectedLocale = SupportedLocales.en,
  disabled = false,
  onChange
}: LocaleSelectorWrapperProps) {
  return (
    <LocaleSelector
      locale={selectedLocale}
      hasBetaLanguage={betaLanguageEnabled}
      onChange={onChange}
      disabled={disabled}
    />
  )
}

export const reactLocaleSelector = createNgReactBridgeDirective(
  'reactLocaleSelector',
  [],
  LocaleSelectorWrapper,
  ['onChange', 'selectedLocale', 'betaLanguageEnabled', 'disabled']
)
